<template>
    <div class="day" v-bind:class="{ disabled: disabled, 'sold-out': soldout }" @click="selectDay">
        <!-- default ticket -->
        <div v-show="isDefault" class="day__inner" v-bind:class="{ selected: selected}">
            <div class="day__date-mob">
                <span class="day__date-mob__day">{{internalDate.format('D')}}</span>
            </div>

            <div class="day__date u-mr-0-sm">
                <span class="day__date__day u-color-gold">{{internalDate.format('D')}}</span>
                <span class="day__date__month u-color-grey">{{internalDate.format('MMM')}}</span>
            </div>

            <div class="day__from-price">
                From <span class="u-t-h6">{{priceLow}}</span>
            </div>

            <div class="day__promo">
            <!-- Emoji placeholder -->
                <svg class="icon-flutes" height="24" viewBox="0 0 22 24" width="22" xmlns="http://www.w3.org/2000/svg"><g><path d="m9.075 2.705c-.075.66.88 1.295 1.27 1.115.275-.13.31-.715.17-1.115-.015-.075-.245-.705-.72-.705-.37311528.04241617-.66973904.33286027-.72.705z"/><path d="m10.97.62c-.1451585.15895133-.2196558.36997213-.206463.58482667.0131929.21485454.112948.41517564.276463.55517333.195.07.5-.19.62-.45 0-.05.22-.46 0-.69-.2020538-.16034493-.4879462-.16034493-.69 0z"/><path d="m11.5 2.615c-.1377409.16741361-.2021341.38330756-.1786064.59882166.0235278.2155141.1329874.41242848.3036064.54617834.2.06.5-.215.6-.5 0-.045.205-.47-.03-.69-.214468-.14654245-.5012202-.12797576-.695.045z"/><path d="m21.325 21.97c-.075-.42-1.54-.66-3-.455l-1.37-5.84c.7876063-.6591545 1.3185341-1.5741199 1.5-2.585.0430135-.3168803.0430135-.6381197 0-.955-.275-2.25-2.205-7.5-2.555-8.425l-4.665 1.09c.13.96.855 6.415 1.5 8.615.0929238.3220564.2327565.6286773.415.91.6166097.8536355 1.5262763 1.4499922 2.555 1.675l1.36 5.805c-1.4.47-2.605 1.335-2.5 1.745.14.5 2.19.33 3.575 0s3.28-1.05 3.185-1.58z"/><path d="m5.94 3.71c-.35.935-2.28 6.175-2.555 8.425-.04301351.3168803-.04301351.6381197 0 .955.18348082 1.0101395.71403641 1.9244636 1.5 2.585l-1.385 5.825c-1.465-.205-2.93.035-3 .455-.095.5 1.81 1.265 3.175 1.585s3.435.5 3.575 0c.115-.41-1.085-1.275-2.5-1.745l1.375-5.795c1.02379868-.2270781 1.92805074-.8233861 2.54-1.675.18224352-.2813227.32207616-.5879436.415-.91.66-2.2 1.39-7.655 1.5-8.615z"/></g></svg> $40.00
            </div>
        </div>
        <!-- disabled ticket -->
        <div v-show="internalDisabled" class="day__inner" v-bind:class="{ selected: selected}">
            <div class="day__date-mob">
                <span class="day__date-mob__day"></span>
            </div>

            <div class="day__date u-mr-0-sm">
                <span class="day__date__day"></span>
                <span class="day__date__month u-color-grey"></span>
            </div>

            <div class="day__message">
                Event closed
            </div>
        </div>
        <!-- soldout ticket -->
        <div v-show="internalSoldout" class="day__inner" v-bind:class="{ selected: selected }">
            <div class="day__date-mob">
                <span class="day__date-mob__day">{{internalDate.format('D')}}</span>
            </div>
            <div class="day__strip day__strip--sold-out">
                <span class="day__strip__text">Sold out</span>
            </div>
            <div class="day__date u-mr-0-sm">
                <span class="day__date__day">{{internalDate.format('D')}}</span>
                <span class="day__date__month u-color-grey">Nov</span>
            </div>
            <div class="day__from-price">
                From <span class="u-t-h6">{{priceLow}}</span>
            </div>
            <div class="day__promo">
                n/a
            </div>
        </div>
        <!-- selling out ticket -->
        <div v-show="internalSellingOut" class="day__inner" v-bind:class="{ selected: selected}">
            <div class="day__date-mob">
                <span class="day__date-mob__day">{{internalDate.format('D')}}</span>
            </div>
            <div class="day__strip day__strip--selling-out">
                <span class="day__strip__text">Selling out</span>
            </div>
            <div class="day__date u-mr-0-sm">
                <span class="day__date__day u-color-gold">{{internalDate.format('D')}}</span>
                <span class="day__date__month u-color-grey">{{internalDate.format('MMM')}}</span>
            </div>
            <div class="day__from-price">
                From <span class="u-t-h6">{{priceLow}}</span>
            </div>
            <div class="day__promo">
                n/a
            </div>
        </div>
        <!-- theme ticket -->
        <div v-show="internalIsThemed" class="day__inner" v-bind:class="{ selected: selected}">
            <div class="day__date-mob">
                <span class="day__date-mob__day">{{internalDate.format('D')}}</span>
            </div>
            <div class="day__date u-mr-0-sm">
                <span class="day__date__day u-color-gold">{{internalDate.format('D')}}</span>
                <span class="day__date__month u-color-grey">{{internalDate.format('MMM')}}</span>
            </div>
            <div class="day__from-price">
                 From <span class="u-t-h6">{{priceLow}}</span>
            </div>
            <div class="day__promo">
                <!-- Emoji placeholder -->
                <svg class="icon-flutes" height="24" viewBox="0 0 22 24" width="22" xmlns="http://www.w3.org/2000/svg"><g><path d="m9.075 2.705c-.075.66.88 1.295 1.27 1.115.275-.13.31-.715.17-1.115-.015-.075-.245-.705-.72-.705-.37311528.04241617-.66973904.33286027-.72.705z"/><path d="m10.97.62c-.1451585.15895133-.2196558.36997213-.206463.58482667.0131929.21485454.112948.41517564.276463.55517333.195.07.5-.19.62-.45 0-.05.22-.46 0-.69-.2020538-.16034493-.4879462-.16034493-.69 0z"/><path d="m11.5 2.615c-.1377409.16741361-.2021341.38330756-.1786064.59882166.0235278.2155141.1329874.41242848.3036064.54617834.2.06.5-.215.6-.5 0-.045.205-.47-.03-.69-.214468-.14654245-.5012202-.12797576-.695.045z"/><path d="m21.325 21.97c-.075-.42-1.54-.66-3-.455l-1.37-5.84c.7876063-.6591545 1.3185341-1.5741199 1.5-2.585.0430135-.3168803.0430135-.6381197 0-.955-.275-2.25-2.205-7.5-2.555-8.425l-4.665 1.09c.13.96.855 6.415 1.5 8.615.0929238.3220564.2327565.6286773.415.91.6166097.8536355 1.5262763 1.4499922 2.555 1.675l1.36 5.805c-1.4.47-2.605 1.335-2.5 1.745.14.5 2.19.33 3.575 0s3.28-1.05 3.185-1.58z"/><path d="m5.94 3.71c-.35.935-2.28 6.175-2.555 8.425-.04301351.3168803-.04301351.6381197 0 .955.18348082 1.0101395.71403641 1.9244636 1.5 2.585l-1.385 5.825c-1.465-.205-2.93.035-3 .455-.095.5 1.81 1.265 3.175 1.585s3.435.5 3.575 0c.115-.41-1.085-1.275-2.5-1.745l1.375-5.795c1.02379868-.2270781 1.92805074-.8233861 2.54-1.675.18224352-.2813227.32207616-.5879436.415-.91.66-2.2 1.39-7.655 1.5-8.615z"/></g></svg> $40.00
            </div>
            <div class="day__theme">
                <div class="day__theme-icon"
                    style="display: inline-block; margin-right: 0.5rem; width: 1rem; height: 1rem; background-color: black;">
                </div>
                    Paws 'n' Claus
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'CalendarDay',
    data: function() {
        return {

        }
    },
    props: ['selected', 'soldout', 'sellingOut', 'disabled', 'isThemed', 'date', 'item', 'priceHigh', 'priceLow'],

    computed: {
        isDefault() {
            return !this.internalSoldout && !this.internalSellingOut && !this.internalDisabled && !this.internalIsThemed;
        },
        internalSelected() {
            if (this.selected) {
                return this.selected;
            } else {
                return false;
            }
        },
        internalSoldout() {
            if (this.soldout) {
                return this.soldout;
            } else {
                return false;
            }
        },
        internalSellingOut() {
            if (this.sellingOut) {
                return this.sellingOut;
            } else {
                return false;
            }
        },
        internalDisabled() {
            if (this.disabled) {
                return this.disabled;
            } else {
                return false;
            }
        },
        internalIsThemed() {
            if (this.isThemed) {
                return this.isThemed;
            } else {
                return false;
            }
        },
        internalDate() {
            if(!this.date) {
                return this.moment();
            }
            return this.date;
        },
        internalPrice() {
            if(this.price) {
                return this.price;
            } else {
                return "";
            }
         },
         internalPriceMin() {
            if(this.item){
                if(this.item.priceLow) {
                    return this.item.priceLow;
                } else {
                    return "";
                }
            } else {
                return "";
            }
            
         },
         internalPriceMax() {
            if(this.item.priceHigh) {
                return this.item.priceHigh;
            } else {
                return "";
            }
         }
    },
    methods: {
        selectDay: function() {
            if(!this.internalDisabled) {
                this.$emit('selected', this.date.format("YYYY-MM-DD"));
            }   
        },
        maxPrice() {
            if(this.internalPriceMin) {
                return this.getCurrencyString(this.internalPriceMin);
            } else {
                return this.getCurrencyString(this.price);
            }
        },
        minPrice() {
            if(this.item){
                if(this.item.priceLow) {
                    return this.item.priceLow;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        getCurrencyString: function(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
    }
}
</script>

<style>

</style>
